import { User } from '@sdk/users/types/User';
import { RestrictionType } from '@sdk/messages/types/RestrictionType';

export type ConversationBasic = {
  id: ID;
  isArchived: boolean;
  isPinned: boolean;
  isPrivate: boolean;
  isSilenced: boolean;
  name: string;
  newestMessageId: ID;
  newestMessagePostedAt: Date;
  newestUnsilencedMessagePostedAt: Date;
  slug: string;
  unreadMessagesCount: number;
};

export type Conversation = ConversationBasic & {
  creatorId: ID;
  firstUnreadMessageId: ID | null;
  interlocutor: User | null;
  isDisabled: boolean;
  memberIds: ID[];
  restricted: RestrictionType;
  restrictedToPersonas: ID[];
};

export enum ConversationFlagKeysEnum {
  IS_ARCHIVED = 'isArchived',
  IS_PINNED = 'isPinned',
  IS_SILENCED = 'isSilenced',
}
